// angular
//   .module('HeroPRO')
//   .controller('AddOfficeAssignmentController', addOfficeAssignmentController);

import _ from 'lodash';
import './addOfficeAssignment.scss';

/* @ngInject */
export default function addOfficeAssignmentController($uibModalInstance, AccountsFactory, currentUserProfile, signedInUserId) {
    const vm = this;
    vm.contentShown = 'addOfficeAssignmentInProgress';
    vm.currentUser = currentUserProfile;
    vm.signedInUserLocations = null;
    vm.locationToAdd = null;

    init();

    /*= =======================================
	=            Public Functions            =
	======================================== */
    vm.closeModal = function () {
        if (vm.contentShown === 'addOfficeAssignmentSuccess') {
            $uibModalInstance.close(vm.locationToAdd);
        } else {
            $uibModalInstance.close();
        }
	 };

	 vm.setNewLocation = function (location) {
        vm.locationToAdd = location;
    };

    vm.addOfficeToUser = function () {
        AccountsFactory.addOfficeToUser({
            ContractorUserId: vm.currentUser.ContractorUserId,
            ContractorLocationId: vm.locationToAdd.ContractorId,
        }).then(() => {
            vm.contentShown = 'addOfficeAssignmentSuccess';
        });
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
	=            Private Functions           =
	======================================== */
    function init() {
        AccountsFactory.getContractorUser(signedInUserId).then((response) => {
            if (vm.currentUser.Locations === undefined || vm.currentUser.Locations.length === 0) {
                vm.signedInUserLocations = response.data.Data.Locations;
            } else {
                // Filter out the locations that the current user already has
                vm.signedInUserLocations = _.reject(response.data.Data.Locations, possibleLocation => _.some(vm.currentUser.Locations, currentLocation => ((possibleLocation.ContractorId === currentLocation.ContractorId))));
            }
    	});
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/accounts/user/addOfficeAssignment/addOfficeAssignmentController.js